import { Theme, css } from '@emotion/react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const input =
  (error: boolean = false) =>
  (theme: Theme) =>
    css`
      && {
        ${error ? `border: 1px solid ${theme.colors.danger}` : ''};
      }
    `;

export const Wrapper = styled.div`
  h1,
  label {
    font-weight: 600;
  }

  p {
    color: #575757;
  }

  .ant-alert-message {
    font-weight: 600;
  }
`;

export const Logo = styled.img`
  display: block;
  max-height: 45px;
  margin-block-end: 0.5rem;
  margin: 0 auto;
  margin-bottom: 23px;
`;

export const ToggleIcon = styled(FontAwesomeIcon, {
  shouldForwardProp: prop => prop !== 'expanded',
})<{ expanded: boolean }>`
  margin-left: 8px;
  transition: transform 0.2s;
  transform: rotate(${({ expanded }) => (expanded ? '180deg' : '0deg')});
`;

export const CredentialsSection = styled.div`
  margin-top: 16px;
`;
